export default {"src":"/_next/static/media/linea.e476f2ad.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};